export const RECOMMENDATIONS_API = {
  getRecommendations: `/recommendations/products`,
};

export const RECOMMENDATIONS_DAYS_THRESHOLD = 60;

export const RECOMMENDATIONS_PAGE_SIZE = 10;
